import { useEffect } from 'react'
import { NotifyCenter } from 'project-config/services/notify-center'
import { useToastStore } from '@/store/toast/toast-store'
import { getTranslateNsT } from '@/utils/get-translate-nst'

export function useResponseInterceptor() {
  const { showGlobalToast } = useToastStore()
  const commonT = getTranslateNsT('common')
  useEffect(() => {
    const axiosResponseInterceptorSubscriber = NotifyCenter.axiosResponseInterceptor.subscribe(
      (response) => {
        if ([404, 502].includes(response.status)) {
          showGlobalToast({
            type: 'error',
            content: commonT('error_network'),
          })
          return
        }
      },
    )
    return () => {
      axiosResponseInterceptorSubscriber.unsubscribe()
    }
  }, [])
}
